import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import _ from 'lodash';

import { mergeFieldPendingChangeAuthors } from 'utils/pendingChangesAuthors';

import { selectFieldPendingChangeAuthorsByEntityKey } from 'store/loanApplications/selectors/pendingChangesAuthors.selectors';

/**
 * Pending-change author rows by field for the entities a read-only view shows (exact change-history
 * keys), to feed the author dots next to its highlighted values. Read a field with
 * getFieldPendingChangeAuthors.
 * @param {...String} entityKeys
 * @returns {Object}
 */
const usePendingChangeAuthors = (...entityKeys) => {
  const fieldAuthorsByEntityKey = useSelector(selectFieldPendingChangeAuthorsByEntityKey);
  const entityKeysDependency = _.compact(entityKeys).join(',');

  return useMemo(
    () =>
      mergeFieldPendingChangeAuthors(
        _.compact(entityKeysDependency.split(',')).map(key => fieldAuthorsByEntityKey[key] ?? {}),
      ),
    [fieldAuthorsByEntityKey, entityKeysDependency],
  );
};

export default usePendingChangeAuthors;
